import React, { useEffect } from "react";
import { Flex, Text } from "styles/utility-components";

import Button from "components/ui/button/Button";
import { DropdownMenu, DropdownMenuItem } from "components/ui/dropdown_menu";
import { useAiToneOfVoices } from "lib/hooks/api/ai_tone_of_voice/useAiToneOfVoices";
import { UIcon } from "../../../lib/icons/untitled_ui/UIcon";

type Props = {
  selectedTovId: string | undefined;
  onSelect: (id: string) => void;
  disabled: boolean;
};

export default function TovDropdown({ selectedTovId, onSelect, disabled }: Props) {
  const { data, isLoading } = useAiToneOfVoices();
  const entries = data ?? [];

  const defaultId = entries.find((e) => e.isDefault)?.id;

  useEffect(() => {
    if (defaultId && !selectedTovId) {
      onSelect(defaultId);
    }
  }, [defaultId, selectedTovId, onSelect]);

  const effectiveSelectedId = selectedTovId ?? defaultId;

  return (
    <DropdownMenu
      side="top"
      align="start"
      width="fit-content"
      trigger={
        <Button icon="edit02" buttonType="secondary" disabled={disabled || isLoading}>
          Tone of voice
        </Button>
      }
    >
      {entries.map((entry) => (
        <DropdownMenuItem key={entry.id} onClick={() => onSelect(entry.id)}>
          <Flex justifyContent="space-between" width="100%" alignItems="center" gap={8}>
            <Text>{entry.label}</Text>
            {entry.id === effectiveSelectedId && (
              <UIcon icon="checkOutlined" size={16} color="sysPrimaryDefault" />
            )}
          </Flex>
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
}
